// extracted by mini-css-extract-plugin
export var caption = "Caption-module--caption--e64b3";
export var captionResponsive = "Caption-module--caption-responsive--d7256";
export var cdsAssistiveText = "Caption-module--cds--assistive-text--e6f80";
export var cdsHideFeedback = "Caption-module--cds--hide-feedback--210b3";
export var cdsShowFeedback = "Caption-module--cds--show-feedback--66a76";
export var cdsSkeleton = "Caption-module--cds--skeleton--a92a4";
export var cdsVisuallyHidden = "Caption-module--cds--visually-hidden--99abf";